import { render, staticRenderFns } from "./VincularAssociacao.vue?vue&type=template&id=6d69feda"
import script from "./VincularAssociacao.vue?vue&type=script&lang=ts"
export * from "./VincularAssociacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports